import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

import { Answer, GetInboxesByPollParserIdWIthPaginationQuery } from 'src/app/core/api/models';
import { InboxesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { LoggerService } from 'src/app/core/services/logger.service';
import { ModalTitleComponent } from "../../../../../shared/global/modal-title/modal-title.component";
import { SearchInputLotteryComponent } from "../../search-input-lottery/search-input-lottery.component";
import { ExpandTextModule } from "../../../../../shared/global/expand-text/expand-text.module";
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';

@Component({
    selector: 'app-poll-parser-lottery-modal',
    templateUrl: './poll-parser-lottery-modal.component.html',
    styleUrls: ['./poll-parser-lottery-modal.component.scss'],
    imports: [
        BaseFormModule,
        ModalTitleComponent,
        SearchInputLotteryComponent,
        ExpandTextModule,
    ]
})
export class PollParserLotteryModalComponent implements OnInit {
  //#region properties
  form: FormGroup;
  pollParserId: number;
  pollParserFormula: Answer[];
  model: GetInboxesByPollParserIdWIthPaginationQuery = {};
  title: string;
  isChecked: any[] = [];
  protected onDestroy$ = new Subject<void>();
  count: number = 1;
  targetAnswer: string;
  loading: boolean = false;
  pollParserLotteryValues: any[] = [];
  isShowWinner: boolean = false;
  pollParserLotteryCount: number;
  isNumberOfWinnersLessThanNumberOfParticipants: boolean = false;
  isParticipants: boolean = true;
  //#endregion

  constructor(
    private inboxService: InboxesService,
    private loggerService: LoggerService,
    private dialogRef: MatDialogRef<PollParserLotteryModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pollParserId = data?.pollParserId;
    this.pollParserFormula = data?.pollParserFormula;
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      count: new FormControl('', [Validators.required, Validators.min(1)]),
    });
  }

  //#region api

  getLotteryApi(pollParserId: string): void {
    this.inboxService
      .inboxesGetInboxesByPollParserLottery({
        PollParserId: pollParserId,
        Count: this.count,
        TargetAnswer: this.targetAnswer,
      })
      .pipe(
        finalize(() => {
          this.loading = false;
        }),
        takeUntil(this.onDestroy$)
      )
      .subscribe((pollParserLottery) => {
        this.isNumberOfWinnersLessThanNumberOfParticipants=false;
        this.isParticipants=false;
        this.isShowWinner=false;

        this.pollParserLotteryValues = pollParserLottery.data;

        this.pollParserLotteryCount = Object.keys(
          this.pollParserLotteryValues
        ).length;

        if (this.pollParserLotteryCount == 0) {
          this.isNumberOfWinnersLessThanNumberOfParticipants = false;
          this.isParticipants = false;
          this.isShowWinner = false;
        } else {
          if (this.pollParserLotteryCount < this.count) {
            this.isNumberOfWinnersLessThanNumberOfParticipants = true;
            this.isParticipants = true;
          }

          this.isShowWinner = true;
          this.isParticipants = true;

        }
      });
  }
  //#endregion

  onClose() {
    this.dialogRef.close();
    this.unSubs();
  }

  unSubs() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onConfirm() {
    if (this.count) this.getLottery(this.pollParserId);
  }

  changePollParserFormula(keyword, counter) {
    try {
      this.isChecked = [];
      this.targetAnswer = null;
      this.isChecked[counter] = true;
      this.targetAnswer = keyword;
      if (this.isShowWinner) {
        this.isParticipants=true;
      }
    } catch (error) {
      this.loggerService.logError(
        'poll-parser-lottery-modal-component',
        error,
        EventTypes.services
      );
    }
  }

  getLottery(parserId) {
    this.unSubs();
    this.loading = true;
    this.getLotteryApi(parserId);
  }
}
